// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/dataset/v1/dataset.proto" (package "viam.app.dataset.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { DatasetService } from "./dataset";
import type { GetSequenceDatasetExportResponse } from "./dataset";
import type { GetSequenceDatasetExportRequest } from "./dataset";
import type { StartSequenceDatasetExportResponse } from "./dataset";
import type { StartSequenceDatasetExportRequest } from "./dataset";
import type { MergeDatasetsResponse } from "./dataset";
import type { MergeDatasetsRequest } from "./dataset";
import type { ListDatasetsByIDsResponse } from "./dataset";
import type { ListDatasetsByIDsRequest } from "./dataset";
import type { ListDatasetsByOrganizationIDResponse } from "./dataset";
import type { ListDatasetsByOrganizationIDRequest } from "./dataset";
import type { RenameDatasetResponse } from "./dataset";
import type { RenameDatasetRequest } from "./dataset";
import type { DeleteDatasetResponse } from "./dataset";
import type { DeleteDatasetRequest } from "./dataset";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateDatasetResponse } from "./dataset";
import type { CreateDatasetRequest } from "./dataset";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * DatasetService is used to manage datasets.
 *
 * @generated from protobuf service viam.app.dataset.v1.DatasetService
 */
export interface IDatasetServiceClient {
    /**
     * CreateDataset makes a new dataset.
     *
     * @generated from protobuf rpc: CreateDataset(viam.app.dataset.v1.CreateDatasetRequest) returns (viam.app.dataset.v1.CreateDatasetResponse);
     */
    createDataset(input: CreateDatasetRequest, options?: RpcOptions): UnaryCall<CreateDatasetRequest, CreateDatasetResponse>;
    /**
     * DeleteDatasets deletes an existing dataset.
     *
     * @generated from protobuf rpc: DeleteDataset(viam.app.dataset.v1.DeleteDatasetRequest) returns (viam.app.dataset.v1.DeleteDatasetResponse);
     */
    deleteDataset(input: DeleteDatasetRequest, options?: RpcOptions): UnaryCall<DeleteDatasetRequest, DeleteDatasetResponse>;
    /**
     * RenameDataset modifies the name of an existing dataset.
     *
     * @generated from protobuf rpc: RenameDataset(viam.app.dataset.v1.RenameDatasetRequest) returns (viam.app.dataset.v1.RenameDatasetResponse);
     */
    renameDataset(input: RenameDatasetRequest, options?: RpcOptions): UnaryCall<RenameDatasetRequest, RenameDatasetResponse>;
    /**
     * ListDatasetsByOrganizationID lists all of the datasets for an organization, optionally filtering by DatasetType.
     *
     * @generated from protobuf rpc: ListDatasetsByOrganizationID(viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest) returns (viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse);
     */
    listDatasetsByOrganizationID(input: ListDatasetsByOrganizationIDRequest, options?: RpcOptions): UnaryCall<ListDatasetsByOrganizationIDRequest, ListDatasetsByOrganizationIDResponse>;
    /**
     * ListDatasetsByIDs lists all of the datasets specified by the given dataset IDs.
     *
     * @generated from protobuf rpc: ListDatasetsByIDs(viam.app.dataset.v1.ListDatasetsByIDsRequest) returns (viam.app.dataset.v1.ListDatasetsByIDsResponse);
     */
    listDatasetsByIDs(input: ListDatasetsByIDsRequest, options?: RpcOptions): UnaryCall<ListDatasetsByIDsRequest, ListDatasetsByIDsResponse>;
    /**
     * MergeDatasets merges multiple datasets into a new dataset.
     *
     * @generated from protobuf rpc: MergeDatasets(viam.app.dataset.v1.MergeDatasetsRequest) returns (viam.app.dataset.v1.MergeDatasetsResponse);
     */
    mergeDatasets(input: MergeDatasetsRequest, options?: RpcOptions): UnaryCall<MergeDatasetsRequest, MergeDatasetsResponse>;
    /**
     * StartSequenceDatasetExport kicks off an async export of all data for a sequence dataset.
     *
     * @generated from protobuf rpc: StartSequenceDatasetExport(viam.app.dataset.v1.StartSequenceDatasetExportRequest) returns (viam.app.dataset.v1.StartSequenceDatasetExportResponse);
     */
    startSequenceDatasetExport(input: StartSequenceDatasetExportRequest, options?: RpcOptions): UnaryCall<StartSequenceDatasetExportRequest, StartSequenceDatasetExportResponse>;
    /**
     * GetSequenceDatasetExport returns the current status of an export job.
     *
     * @generated from protobuf rpc: GetSequenceDatasetExport(viam.app.dataset.v1.GetSequenceDatasetExportRequest) returns (viam.app.dataset.v1.GetSequenceDatasetExportResponse);
     */
    getSequenceDatasetExport(input: GetSequenceDatasetExportRequest, options?: RpcOptions): UnaryCall<GetSequenceDatasetExportRequest, GetSequenceDatasetExportResponse>;
}
/**
 * DatasetService is used to manage datasets.
 *
 * @generated from protobuf service viam.app.dataset.v1.DatasetService
 */
export class DatasetServiceClient implements IDatasetServiceClient, ServiceInfo {
    typeName = DatasetService.typeName;
    methods = DatasetService.methods;
    options = DatasetService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * CreateDataset makes a new dataset.
     *
     * @generated from protobuf rpc: CreateDataset(viam.app.dataset.v1.CreateDatasetRequest) returns (viam.app.dataset.v1.CreateDatasetResponse);
     */
    createDataset(input: CreateDatasetRequest, options?: RpcOptions): UnaryCall<CreateDatasetRequest, CreateDatasetResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateDatasetRequest, CreateDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * DeleteDatasets deletes an existing dataset.
     *
     * @generated from protobuf rpc: DeleteDataset(viam.app.dataset.v1.DeleteDatasetRequest) returns (viam.app.dataset.v1.DeleteDatasetResponse);
     */
    deleteDataset(input: DeleteDatasetRequest, options?: RpcOptions): UnaryCall<DeleteDatasetRequest, DeleteDatasetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteDatasetRequest, DeleteDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * RenameDataset modifies the name of an existing dataset.
     *
     * @generated from protobuf rpc: RenameDataset(viam.app.dataset.v1.RenameDatasetRequest) returns (viam.app.dataset.v1.RenameDatasetResponse);
     */
    renameDataset(input: RenameDatasetRequest, options?: RpcOptions): UnaryCall<RenameDatasetRequest, RenameDatasetResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<RenameDatasetRequest, RenameDatasetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListDatasetsByOrganizationID lists all of the datasets for an organization, optionally filtering by DatasetType.
     *
     * @generated from protobuf rpc: ListDatasetsByOrganizationID(viam.app.dataset.v1.ListDatasetsByOrganizationIDRequest) returns (viam.app.dataset.v1.ListDatasetsByOrganizationIDResponse);
     */
    listDatasetsByOrganizationID(input: ListDatasetsByOrganizationIDRequest, options?: RpcOptions): UnaryCall<ListDatasetsByOrganizationIDRequest, ListDatasetsByOrganizationIDResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDatasetsByOrganizationIDRequest, ListDatasetsByOrganizationIDResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * ListDatasetsByIDs lists all of the datasets specified by the given dataset IDs.
     *
     * @generated from protobuf rpc: ListDatasetsByIDs(viam.app.dataset.v1.ListDatasetsByIDsRequest) returns (viam.app.dataset.v1.ListDatasetsByIDsResponse);
     */
    listDatasetsByIDs(input: ListDatasetsByIDsRequest, options?: RpcOptions): UnaryCall<ListDatasetsByIDsRequest, ListDatasetsByIDsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListDatasetsByIDsRequest, ListDatasetsByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * MergeDatasets merges multiple datasets into a new dataset.
     *
     * @generated from protobuf rpc: MergeDatasets(viam.app.dataset.v1.MergeDatasetsRequest) returns (viam.app.dataset.v1.MergeDatasetsResponse);
     */
    mergeDatasets(input: MergeDatasetsRequest, options?: RpcOptions): UnaryCall<MergeDatasetsRequest, MergeDatasetsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<MergeDatasetsRequest, MergeDatasetsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * StartSequenceDatasetExport kicks off an async export of all data for a sequence dataset.
     *
     * @generated from protobuf rpc: StartSequenceDatasetExport(viam.app.dataset.v1.StartSequenceDatasetExportRequest) returns (viam.app.dataset.v1.StartSequenceDatasetExportResponse);
     */
    startSequenceDatasetExport(input: StartSequenceDatasetExportRequest, options?: RpcOptions): UnaryCall<StartSequenceDatasetExportRequest, StartSequenceDatasetExportResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<StartSequenceDatasetExportRequest, StartSequenceDatasetExportResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * GetSequenceDatasetExport returns the current status of an export job.
     *
     * @generated from protobuf rpc: GetSequenceDatasetExport(viam.app.dataset.v1.GetSequenceDatasetExportRequest) returns (viam.app.dataset.v1.GetSequenceDatasetExportResponse);
     */
    getSequenceDatasetExport(input: GetSequenceDatasetExportRequest, options?: RpcOptions): UnaryCall<GetSequenceDatasetExportRequest, GetSequenceDatasetExportResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSequenceDatasetExportRequest, GetSequenceDatasetExportResponse>("unary", this._transport, method, opt, input);
    }
}
